import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class PopUp extends Component {
	render() {
		const { children } = this.props;

		return <div className="main-layout-popup">{children}</div>;
	}
}
PopUp.propTypes = {
	children: PropTypes.node
};

export default PopUp;
